import type React from 'react'

/**
 * Whether a click on a link should be left to the browser: a modifier key
 * (new tab, new window, download), any button but the primary one, or a
 * target other than this tab. Only a plain left click is an in-app navigation.
 */
export const isBrowserClick = (event: React.MouseEvent<HTMLAnchorElement>): boolean => {
  if (event.defaultPrevented) return true
  if (event.button !== 0) return true
  if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return true
  const target = event.currentTarget.getAttribute('target')
  return Boolean(target && target !== '_self')
}

/**
 * Classes that turn a link into a "stretched link": its `::after` covers the
 * nearest positioned ancestor, so the whole card answers the click, while the
 * buttons inside the card (`relative z-10`) stay buttons and stay on top.
 * The ring is drawn on the overlay, so keyboard focus outlines the whole card.
 */
export const stretchedLinkClass =
  'after:absolute after:inset-0 focus-visible:outline-none focus-visible:after:ring-2 focus-visible:after:ring-inset focus-visible:after:ring-primary'
